import React from 'react';
import styles from './VendorSaleList.module.css';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import {
    contentStart,
    saleFontSize1,
    saleMargin1,
    commonFontWeight700,
    contentCenter,
    infoBorderColor,
    salePadding1,
} from 'routes/vendorRe/constraint/constraints';

const VendorSaleList = ({ data }) => {
    // 

    // data가 없는 경우 처리
    if (!data) {
        return null;
    }

    return (
        <FlexChild maxWidth={"32%"}>
            <div style={{ padding: "1rem 0 0 0" }}>
                <div className={styles.saleListCont}>
                    <VerticalFlex gap={10} >
                        <FlexChild justifyContent={contentCenter} border={"1px solid #D9D9D9D9"} overflowX={"hidden"} borderRadius={10}>
                            <img className={styles.liquid} src={data.productImg} alt='액상담배 썸네일' />
                        </FlexChild>
                        <FlexChild >
                            <VerticalFlex>
                                <FlexChild alignItems={contentStart}>
                                    <P
                                        ellipsis
                                        overflow="hidden"
                                        whiteSpace="nowrap"
                                        size={"min(2.6vw, 22px)"}
                                        weight={700}
                                        maxWidth="100%"
                                    >
                                        {data.productName}
                                    </P>
                                    {/* {
                                        data.price &&
                                        <P size={"min(2.6vw, 20px)"} >{data.price ? data.price.toLocaleString() : 0}</P>
                                    } */}

                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        {/* <FlexChild justifyContent={contentCenter}> */}
                        <FlexChild justifyContent={"flex-start"} alignItems={"flex-start"} >
                            <HorizontalFlex gap={10}>
                                <FlexChild width={'fit-content'}>
                                    <P size={"min(2.6vw, 20px)"} weight={700} color={"#626D7D"}>판매량 </P>
                                </FlexChild>
                                <FlexChild>
                                    <P color={"#FE531F"} size={"min(2.6vw, 20px)"} weight={700}>{data.totalQuantity ? data.totalQuantity : data.quantity ? data.quantity : 0}</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </div>
            </div>
        </FlexChild>
    );
};

export default VendorSaleList;